import * as React from 'react'

import { useI18n } from '@thg-commerce/enterprise-core'
import { ModalRenderer } from '@thg-commerce/enterprise-modal'

import { DeliveryReturnsModal } from './DeliveryReturnsModal'
import { TabProps } from '@thg-commerce/gravity-patterns/Tabs/Tabs'

export interface DeliveryReturnsModalPresenterProps {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  headerHeight: number
  tabIndex?: number
  focusedSectionId?: string
  dropshipRichContent?: {
    deliveryInformation: string
    returnsInformation: string
  }
  setTabs?: React.Dispatch<React.SetStateAction<TabProps[] | undefined>>
}

export const DeliveryReturnsModalPresenter = ({
  isOpen,
  setIsOpen,
  headerHeight,
  tabIndex,
  focusedSectionId,
  dropshipRichContent,
  setTabs,
}: DeliveryReturnsModalPresenterProps) => {
  const i18n = useI18n()
  const modalCloseI18nText = {
    closeAriaLabel: i18n('general.modal.close.button.arialabel'),
    closeLabel: i18n('general.modal.close.button.label'),
  }

  if (!isOpen) {
    return null
  }

  return (
    <ModalRenderer
      onClose={() => setIsOpen(false)}
      gridColSpan={[12, 6, 8, 8]}
      headerOffset={headerHeight}
      closeI18nText={modalCloseI18nText}
      contentPadding="0 0 16px 0"
      showHeader={true}
      stickyHeader={true}
      renderContent={() => (
        <DeliveryReturnsModal
          dropshipRichContent={dropshipRichContent}
          tabIndex={tabIndex}
          focusedSectionId={focusedSectionId}
          setTabs={setTabs}
        />
      )}
    />
  )
}
